<div class="loading-input-container">
  <div class="loading-shimmer label"></div>
  <div class="loading-shimmer content"></div>
</div>
